import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Shield, ExternalLink } from 'lucide-react';

const Policy = () => {
  const policies = [
    {
      title: 'Admission Policy',
      description: 'Guidelines and procedures for student admissions',
      link: '#'
    },
    {
      title: 'Anti-Ragging Policy',
      description: 'Zero tolerance policy against ragging',
      link: '#'
    },
    {
      title: 'Grievance Redressal Policy',
      description: 'Process for addressing student and staff grievances',
      link: '#'
    },
    {
      title: 'Code of Conduct',
      description: 'Expected behavior standards for students and staff',
      link: 'https://www.davcommercesolapur.org/DAV/Code%20of%20Professional%20Ethics%20DAV.pdf'
    },
    {
      title: 'Internal Complaints Committee (ICC) Policy',
      description: 'Prevention of sexual harassment at workplace',
      link: '#'
    },
    {
      title: 'RTI Policy',
      description: 'Right to Information Act implementation',
      link: 'https://davcommercesolapur.com/DAV/RTI.pdf'
    },
    {
      title: 'Examination Policy',
      description: 'Rules and regulations for examinations',
      link: '#'
    },
    {
      title: 'Attendance Policy',
      description: 'Minimum attendance requirements',
      link: '#'
    },
    {
      title: 'Library Policy',
      description: 'Library usage rules and book lending policy',
      link: '#'
    },
    {
      title: 'IT Policy',
      description: 'Acceptable use of college IT resources',
      link: '#'
    },
    {
      title: 'Infrastructure Utilization Policy',
      description: 'Maintenance and utilization of college infrastructure',
      link: 'https://www.davcommercesolapur.org/DAV/Infrastructure%20Utilization%20policy.pdf'
    },
    {
      title: 'Research Ethics Policy',
      description: 'Guidelines for ethical research practices',
      link: '#'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#000066] mb-2 flex items-center gap-3">
            <Shield className="w-10 h-10" />
            Policies and Procedures
          </h1>
          <p className="text-gray-600">College policies and guidelines for smooth functioning</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {policies.map((policy, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-all duration-300 border-t-4 border-[#FF4500]"
            >
              <h3 className="text-xl font-bold text-[#000066] mb-2">
                {policy.title}
              </h3>
              <p className="text-gray-600 mb-4">{policy.description}</p>
              <a
                href={policy.link}
                target={policy.link.startsWith('http') ? '_blank' : '_self'}
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#FF4500] font-semibold hover:text-[#FF5722] transition-colors"
              >
                Read Policy
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Policy;